import { IconPlus } from "@tabler/icons-react";

import { Button } from "../../../components/shared/Button/Button";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { setSectionProperty } from "../../../redux/slices/generatorSlice";
import { useMarkRowUnsaved } from "src/generator/hooks/useMarkRowUnsaved";
import {
  parseHeadersIntoDoubled,
  parseRowsIntoDoubled,
} from "./AddCommentsButton.utils";
import { setEditing } from "src/redux/slices/entrySlice";

interface Props {
  sectionIndex: number;
  rowIndex: number;
}

const AddCommentsButton = ({ sectionIndex, rowIndex }: Props) => {
  const dispatch = useDispatch();
  const { lbentry } = useSelector(state => state.generatorSlice);
  const { locked, you } = useSelector(state => state.entrySlice);
  const { markRowAsUnsaved } = useMarkRowUnsaved(sectionIndex, rowIndex);

  const handleAddComments = () => {
    const clonedSection = structuredClone(lbentry.sections[sectionIndex]);
    const parsedRows = parseRowsIntoDoubled(clonedSection.rows, rowIndex);

    const parsedHeaders = parseHeadersIntoDoubled(
      parsedRows,
      clonedSection.headers,
    );
    dispatch(
      setSectionProperty({ sectionIndex, property: { rows: parsedRows } }),
    );
    dispatch(
      setSectionProperty({
        sectionIndex,
        property: { headers: parsedHeaders },
      }),
    );
    dispatch(setEditing(true));
    markRowAsUnsaved(parsedRows[rowIndex]);
  };

  return (
    <Button
      variant="outline"
      leftSection={<IconPlus />}
      onClick={handleAddComments}
      disabled={locked && !you}>
      Comment
    </Button>
  );
};
export default AddCommentsButton;
